import { NOTIFICATIONS } from 'constants/api';
import axios from 'utils/axios';

export const getNotifications = async (data) => {
    const result = await axios.get(NOTIFICATIONS.v2.fetchNotifications, {
        params: data
    });
    return result.data;
};

export const markReadNotifications = async (data) => {
    const result = await axios.put(`${NOTIFICATIONS.v2.markRead}`, data);
    return result.data;
};
